import TranslationWithTicketRef from './TicketNumberLink';
import LitigationContent from './LitigationContent';

const ReturnLitigationDescriptionDone = ({
  canAccessReturnForm,
  zenDeskLinkInfo,
  litigationDecision,
  zendeskTicketStatus,
  productId,
}: {
  canAccessReturnForm: boolean;
  zenDeskLinkInfo: { link: string; ticketId: string };
  litigationDecision: string;
  zendeskTicketStatus: string;
  productId: number;
}) => {
  const ZENDESK_TICKET_CLOSED_STATUS = 'CLOSED';
  const ZENDESK_TICKET_CLOSED_NO_DECISION_STATUS = 'FAIL_ZENDESK_MERGED_AND_CLOSED';
  const OMS_LITIGATION_AGREE = 'AGREE';
  const OMS_LITIGATION_DISAGREE = 'DISAGREE';

  let descriptionContent = <div />;

  const isLitigationDecisionAgree = litigationDecision === OMS_LITIGATION_AGREE;
  const isLitigationDecisionDisagree = litigationDecision === OMS_LITIGATION_DISAGREE;

  const isZendeskTicketClosed = [ZENDESK_TICKET_CLOSED_STATUS, ZENDESK_TICKET_CLOSED_NO_DECISION_STATUS].includes(
    zendeskTicketStatus || '',
  );

  const ticketStatus = isZendeskTicketClosed ? 'closed' : 'not_closed';
  let translateKeySuffix = '';

  if (!isLitigationDecisionAgree && !isLitigationDecisionDisagree) {
    translateKeySuffix = 'oms_not_agree_disagree.description';
  } else if (isLitigationDecisionAgree) {
    translateKeySuffix = 'oms_agree.description';
  } else if (canAccessReturnForm) {
    translateKeySuffix = 'oms_accept.description';
  }

  descriptionContent = (
    <TranslationWithTicketRef
      {...zenDeskLinkInfo}
      translateKey={`oms_return_status.create_return_litigation.exist_ticket.${ticketStatus}.${translateKeySuffix}`}
    />
  );

  return (
    <LitigationContent
      productId={productId}
      descriptionContent={descriptionContent}
    />
  );
};

export default ReturnLitigationDescriptionDone;
